import request from '@/utils/request'
import requestTag from '@/utils/requestTag'
import Export from '@/utils/export'
import store from '@/store'

// 所属产品---废弃
const baseUrl = "http://10.10.10.174"
export function getProject() {
  return request({
    url: `common/get-all-project`,
    method: 'get'
  })
}
// 需求难度

export function setTaskDegreeOfDifficulty(data) {
  return request({
    url: '/demand/setDemandDegreeOfDifficulty',
    method: 'post',
    data: data
  })
}
// 所有需求里的状态的下拉框

export function getDemandStatus() {
  return request({
    url: `demand/get-demand-status`,
    method: 'get'
  })
}
// 所属模块
export function getModel(projectId) {
  return request({
    url: `common/get-by-project-model?project_id=${projectId}`,
    method: 'get'
  })
}
export function getModelList(params) {
  return request({
    url: `common/get-by-project-model`,
    method: 'get',
    params: params
  })
}
// 需求来源
export function getDemandFrom(data) {
  return request({
    url: `demand/get-source-of-demand`,
    method: 'get',
    params: data
  })
}

export function configBusiness(params) {
  return request({
    url: `common/config-business`,
    method: 'get',
    params
  })
}
// 所属版本计划
export function getVersion(userId) {
  return request({
    url: `demand/get-by-user-version?user_id=${userId}`,
    method: 'get'
  })
}

// 获取所有产品id / 所属产品
export function getProjectList(userId) {
  return request({
    url: `common/get-by-user-project?user_id=${store.getters.userId}`,
    method: 'get'
  })
}

// 需求列表
export function getDemandList(reqParams) {
  return request({
    url: `demand/demand-list`,
    method: 'post',
    data: reqParams
  })
}

// 按钮查询
export function demandStatus(reqParams) {
  return request({
    // url: `/task/select?${taskName}=${taskInfo}`,
    // url: `demand/demand-list?project_id=${project}&status=${demandStatus}`,
    url: `demand/demand-list`,
    method: 'post',
    data: reqParams
  })
}

// 创建需求
export function saveForm(reqParams) {
  return request({
    url: `demand/add-demand`,
    method: 'post',
    data: reqParams
  })
}

export function setDemandEstimateTime(reqParams) {
  return request({
    url: `/demand/setDemandEstimateTime`,
    method: 'post',
    data: reqParams
  })
}

// 关闭/暂停 等弹框
export function updateStatus(reqParams) {
  return request({
    url: `demand/update-demand-status`,
    method: 'post',
    data: reqParams
  })
}
// 继续  有任务并且是测试完成

export function demandContinue(reqParams) {
  return request({
    url: `/demand/demand-continue`,
    method: 'post',
    data: reqParams
  })
}
// 提交备注
export function submitRemark(reqParams) {
  return request({
    url: `common/create-log`,
    method: 'post',
    data: reqParams
  })
}

// 导出
export function exportDemand(params) {
  return Export({
    url: `demand/export-demand`,
    method: 'get',
    params: params,
    responseType: 'blob'
  })
}
// 邮件分组
export function getEmail() {
  return request({
    url: `demand/demand-mail`,
    method: 'get'
  })
}
// 邮件分组
export function etaEdit(data) {
  return request({
    url: `demand/demand-eta-edit`,
    method: 'post',
    data: data
  })
}

export function checkDemandDay(data) {
  return request({
    url: `demand/check-demand-day`,
    method: 'get',
    params: data
  })
}
// 废弃激活
export function dactivateDemand(data) {
  return request({
    url: `demand/demand-dactivate`,
    method: 'post',
    data: data
  })
}
// 新增需求来源
export function addDemandSource(data) {
  return request({
    url: `demand/add-source-of-demand`,
    method: 'post',
    data: data
  })
}
// 需求来源
export function updateDemandSource(data) {
  return request({
    url: `demand/update-source-of-demand`,
    method: 'post',
    data: data
  })
}

// 通知需求方
export function notifyEmployer(data) {
  return request({
    url: `demand/send-template-mail`,
    method: 'post',
    data: data
  })
}
// 修改处理人
export function demandUserUpdate(data) {
  return request({
    url: `demand/demand-user-update`,
    method: 'post',
    data: data
  })
}
// 上传代码记录 http://190.168.1.50:8085/api/demand/upload-code
export function demanduploadCode(data) {
  return request({
    url: `demand/upload-code`,
    method: 'post',
    data: data
  })
}
// 判断需求下面的任务 是否全部测试完成
export function isallCompleted(params) {
  return request({
    url: `/demand/demand-all-task-completed/`,
    method: 'get',
    params
  })
}
// 驳回
export function refuseToDraft(params) {
  return request({
    url: `demand/update-demand-status`,
    method: 'post',
    data: params
  })
}
// 设置标签
export function setTag(params) {
  return request({
    url: `demand/setTag`,
    method: 'post',
    data: params
  })
}
// 获取集合标签
export function getTagList(params) {
  return request({
    url: `demand/getTagList`,
    method: 'get'
  })
}
// 删除标签
export function deleteTag(params) {
  return requestTag({
    url: `demand/deleteTag`,
    method: 'get',
    params: params
  })
}
// 删除标签(硬删除)
export function deleteTrueTag(params) {
  return requestTag({
    url: `demand/deleteTagName`,
    method: 'get',
    params: params
  })
}
// 添加标签到标签库
export function addTagtoCage(params) {
  return requestTag({
    url: `demand/addTag`,
    method: 'get',
    params: params
  })
}
// 创建需求
export function getProjectType(params) {
  return request({
    url: `demand/project-type`,
    method: 'get',
    data: params
  })
}
// 评分人群和时间提交
export function getScoreSet(params) {
  return request({
    url: `demand/scoreSet`,
    method: 'post',
    data: params
  })
}
// 查询标签
export function getTagByDemand(params) {
  return request({
    url: `demand/getTagByDemand`,
    method: 'get',
    params
  })
}
// 获取项目列表，用于获取有权限上传的项目
export function getAuthUploadProjects(params) {
  return request({
    url: `project/user-system`,
    method: 'get',
    params
  })
}
//查询个人的需求
export function getUploadProjectsByUserid(data) {
  return request({
    url: `demand/user-demand`,
    method: 'post',
    data
  })
}

//激活编写用例
export function writingUseCases(data) {
  return request({
    url: `demand/writingUseCases`,
    method: 'post',
    data
  })
}

// 废弃需求判断 是否是最后一个需求
export function taskisDiscard(data) {
  return request({
    url: `task/isDiscard`,
    method: 'post',
    data
  })
}
// 获取的用例状态
export function getTestStatus(data) {
  return request({
    url: `demand/demand-case-info`,
    method: 'get',
    params:data
  })
}
